<template lang="pug">
#ferramentas-sentinel
    el-drawer(
        :title="$t('mensagens.ferramentaSentinelHub.titulo')"
        direction='rtl',
        :class='menuMaior ? "ferramentas-sentinel" : "ferramentas-sentinel menor"',
        :visible.sync='show',
        :before-close='closeFerramentasSentinelHub',
        :wrapperClosable='false',
        :modal='false',
        :lock-scroll='true',
        :append-to-body='false',
        :close-on-press-escape='true',
        :size='menuMaior ? 360 : 247'
    )
        template(slot='title', slot-scope='scope')
            div(:class='menuMaior ? "titulo-drawer" : "titulo-drawer-menor"')
                i.mdi.mdi-satellite-variant
                |
                | {{ title }}

        .card-container
            span {{ $t('mensagens.ferramentaSentinelHub.nuvem.info') }}
            div.mt-3
                span {{ $t('mensagens.ferramentaSentinelHub.datepicker.titulo') }}
            .filtro-data
                    el-date-picker#mesVigenteExtratoConsulta(
                        v-model='datas',
                        type='daterange',
                        :range-separator='$t("mensagens.ferramentaSentinelHub.datepicker.separator")',
                        :start-placeholder='$t("mensagens.ferramentaSentinelHub.datepicker.dataInicio")',
                        :end-placeholder='$t("mensagens.ferramentaSentinelHub.datepicker.dataFim")'
                        format='dd/MM/yyyy',
                        :append-to-body='true',
                        @change='mudarMesVigenteConsulta'
                    )
            div.mt-3
                span {{ $t('mensagens.ferramentaSentinelHub.nuvem.titulo') }}
            div.nuvens
                i.mdi.mdi-cloud-outline.icone
                el-slider.slider(
                    v-model='percentualNuvens'
                )
            div.mt-3
                span {{ $t('mensagens.ferramentaSentinelHub.camadas.titulo') }}
            el-menu(
                :default-active='defaultActive',
                :class='menuMaior ? "" : "menu-menor"',
                :collapse='false',
                @select='processarEscolhaMenu'
            )
                div(v-for='camada in camadas', :key='camada.index')
                        el-menu-item(
                            v-if='camada.hasPermission',
                            :index='camada.index',
                            :disabled='camada.disabled'
                        )
                            img(:src='getImgUrl(camada.image)')
                            span(slot='title') {{ camada.name }}
                            el-col(:span='6')
            BaseButton.botao-consultar-imagens(
                id="botao-ativar",
                type='primary',
                @click='ativarCamadas',
                icon='mdi mdi-power'
            ) {{ $t('mensagens.ferramentaSentinelHub.botao.ativar.titulo') }}

            BaseButton.botao-cancela-consultar-imagens.none(
                id="botao-desativar",
                type='primary',
                @click='limparParametros',
                icon='mdi mdi-stop-circle-outline'
            ) {{ $t('mensagens.ferramentaSentinelHub.botao.desativar.titulo') }}

</template>

<script>
import L from 'leaflet';
import { URL_WMS_SENTINEL } from '@/utils/mapa/mapa.config';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'FerramentasSentinelHub',

    components: {
        BaseButton
    },

    props: {
        show: {
            type: Boolean,
            required: false,
            default: false
        },
        menuMaior: {
            type: Boolean,
            required: false,
            default: false
        },
        mapConfigControls: {
            type: Object,
            required: true,
            default: () => {
                return {};
            }
        },
        mapa: {
            type: Object
        },
        selectorIdMapa: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            defaultActive: '',
            percentualNuvens: 20,
            layerSentinelHub: null,
            datas: [],
            selectedLayerName: 'TRUE-COLOR-S2L2A',
            mudarCamada: false
        };
    },

    computed: {
        title() {
            return this.$t('mensagens.ferramentaSentinelHub.titulo');
        },

        camadas() {
            return [
                {
                    index: '0',
                    name: this.$t('mensagens.ferramentaSentinelHub.camadas.corNatural'),
                    image: 'cor-natural.png',
                    value: 'TRUE-COLOR-S2L2A',
                    hasPermission: true,
                    hasSubOptions: false
                },
                {
                    index: '1',
                    name: this.$t('mensagens.ferramentaSentinelHub.camadas.agricultura'),
                    image: 'agricultura.png',
                    value: 'AGRICULTURE',
                    hasPermission: true,
                    hasSubOptions: false
                },
                {
                    index: '2',
                    name: this.$t('mensagens.ferramentaSentinelHub.camadas.infravermelho'),
                    image: 'infra-vermelho.png',
                    value: 'FALSE-COLOR',
                    hasPermission: true,
                    hasSubOptions: false
                },
                {
                    index: '3',
                    name: this.$t('mensagens.ferramentaSentinelHub.camadas.indiceUmidade'),
                    image: 'indice-umidade.png',
                    value: 'MOISTURE-INDEX',
                    hasPermission: true,
                    hasSubOptions: false
                },
                {
                    index: '4',
                    name: this.$t('mensagens.ferramentaSentinelHub.camadas.indiceVegetacao'),
                    image: 'indice-vegetacao.png',
                    value: 'NDVI',
                    hasPermission: true,
                    hasSubOptions: false
                }
            ];
        }
    },

    watch: {
        limparMenuFerramentasAtivo(newValue) {
            if (newValue) {
                this.defaultActive = '';
                setTimeout(() => {
                    this.$emit('resetarLimparMenuFerramentasAtivo');
                }, 100);
            }
        }
    },

    methods: {
        closeFerramentasSentinelHub() {
            this.$emit('closeFerramentasSentinelHub');
        },

        setHabilitado(habilitado) {
            this.habilitado = habilitado;

            if (this.habilitado) {
                this.mostrarCamada();
            } else {
                this.esconderCamada();
            }
        },

        ativarCamadas() {
            this.mudarCamada = true;
            this.aplicarParametros();
        },

        mudarMesVigenteConsulta(event) {
            this.setHabilitado(false);
            this.alternaBotao('botao-desativar', 'botao-ativar');
            this.datas = event;
            this.$emit('mudarMesVigenteConsulta', event);
            setTimeout(() => {
                $(this.selectorIdMapa + ' .leaflet-top').removeClass(
                    'fullscreen-ativado'
                );
            }, 10);
        },

        aplicarParametros() {
            const startTime = this.datas[0].toISOString();
            const endTime = this.datas[1].toISOString();

            const maxNuvens = this.percentualNuvens || 20;

            this.limparCamada();

            this.layerSentinelHub = L.tileLayer.wms(URL_WMS_SENTINEL, {
                layers: this.selectedLayerName,
                minZoom: 12,
                time: `${startTime}/${endTime}`,
                maxCC: maxNuvens
            });
            this.layerSentinelHub.addTo(this.mapa);

            this.setHabilitado(true);

            this.zoomIn();
            this.alternaBotao('botao-ativar', 'botao-desativar');
            this.$store.dispatch('processarEventoGoogleAnalytics', { eventLabel: 'VISUALIZAR_CAMADA_SENTINEL_HUB', pageTitle: 'VISUALIZAR_CAMADA_SENTINEL_HUB', routeName: this.$route?.name, routePath: this.$route?.path });
        },
        alternaBotao(idBotaoAtivar, idBotaoDesativar) {
            $(`#${idBotaoAtivar}`).addClass('none');
            $(`#${idBotaoDesativar}`).removeClass('none');
        },
        limparParametros() {
            this.limparCamada();
            this.alternaBotao('botao-desativar', 'botao-ativar');
            $('.el-menu-item').removeClass('is-active');
            this.selectedLayerName = 'TRUE-COLOR-S2L2A';
            this.mudarCamada = false;
        },
        limparCamada() {
            if (this.layerSentinelHub) {
                this.mapa.removeLayer(this.layerSentinelHub);
                this.layerSentinelHub = null;
            }
        },
        mostrarCamada() {
            if (this.layerSentinelHub && !this.layerSentinelHub._map) {
                this.mapa.addLayer(this.layerSentinelHub);
            }
        },
        esconderCamada() {
            if (this.layerSentinelHub && this.layerSentinelHub._map) {
                this.mapa.removeLayer(this.layerSentinelHub);
            }
        },
        zoomIn() {
            if (this.mapa.getZoom() < 12) {
                this.mapa.setZoom(12);
            }
        },

        processarEscolhaMenu(opcao) {
            this.selectedLayerName = this.camadas[opcao].value;
            if (this.mudarCamada) {
                this.aplicarParametros();
            }
        },

        getImgUrl(pic) {
            // eslint-disable-next-line
            return require(`@/assets/camadas/${pic}`);
        }
    }
};
</script>

<style lang="scss">
#ferramentas-sentinel {
    font-family: 'Roboto', 'sans serif';

    .el-drawer.rtl {
        border-radius: 0 3px 3px 0;
    }

    .ferramentas-sentinel {
        z-index: 500 !important;
        position: absolute;

        #el-drawer__title > button > i {
            &::before {
                color: #3b3b3b;
                font-weight: 600;
                font-size: 16px;
            }
        }
    }

    .menor {
        .el-range__close-icon {
                width: 20px;
            }
    }

    .ferramentas-sentinel.menor {
        #el-drawer__title > button > i {
            &::before {
                color: #3b3b3b;
                font-weight: 600;
                font-size: 14px;
            }
        }
        .el-input__inner input {
            font-size: 12px;

            .el-range__close-icon {
                width: 20px;
            }
        }
        .el-date-editor .el-range-separator {
            font-size: 12px;
            width: 6%;
        }
        .el-menu {
            .el-menu-item,
            .el-submenu__title {
                height: 50px;
                line-height: 50px;
                img {
                    width: 45px;
                    height: 45px;
                }
                span {
                    font-size: 13px;
                    line-height: 13px;
                }
            }
        }
        .card-container {
            span {
                font-size: 13px;
            }
        }
    }

    .el-drawer__body {
        @include scroll-bar();
    }

    .card-container {
        span {
            font-size: 14px;
        }
        height: 100%;
        background-color: var(--white);
        padding: 5px 8px;
        overflow-y: auto;
        overflow-x: hidden;

        .filtro-data {
            min-width: 26%;
            .el-date-editor.el-input,
            .el-date-editor.el-input__inner {
                width: 100% !important;
            }
        }
        
        .nuvens {
            display: flex;
            border: 1px solid lightgray;
            border-radius: 5px;
            padding: 5px;
            margin-top: 5px;

            .icone {
                font-size: 20px;
                color: lightgray;
                padding: 0 10px 0 10px;
            }

            .slider {
                width: 100%;
                padding-top: 7px;
            }
        }

        .el-menu {
            display: flex;
            border: 1px solid lightgray;
            border-radius: 5px;
            padding: 5px;
            margin-top: 5px;
            width: 100%;
            flex-direction: column;

            .el-menu-item,
            .el-submenu__title {
                border-bottom: 1px solid lightgray;;
                padding: 0 !important;
                border-radius: 5px;
                display: -webkit-box;
                justify-content: center;
                align-items: center;
                height: 60px;
                line-height: 60px;

                i {
                    color: #3b3b3b;
                    transition: all 0.3s ease-in-out;
                }

                i.mdi {
                    margin-right: 11px;
                    text-align: center;
                    font-size: 22px;
                    vertical-align: middle;
                }

                i.el-icon-arrow-down {
                    transform: rotate(270deg);
                    color: #3b3b3b;
                    font-size: 16px;
                    font-weight: 600;
                }

                span {
                    padding: 0;
                    width: 100%;
                    color: #3b3b3b;
                    font-weight: 400;
                    font-size: 14px;
                    transition: color 0.3s ease-in-out;
                    display: flex;
                    justify-content: space-between;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                    line-height: 16px;
                    letter-spacing: 0em;
                    text-align: left;
                }

                .el-tooltip {
                    padding: 0px 18px;
                }
            }

            .el-submenu__icon-arrow {
                right: 10px;
            }

            .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
                transform: rotate(360deg) !important;
            }

            .el-menu-item.is-active {
                color: var(--primary);
                background-color: #b5dc6966;

                i {
                    color: var(--primary);
                }

                span {
                    color: var(--primary);
                    font-weight: 500;
                }
            }
        }
    }

    .titulo-drawer {
        font-size: 17px;
        font-weight: 500;
        color: var(--primary);
    }

    .titulo-drawer-menor {
        font-size: 15px;
        font-weight: 500;
        color: var(--primary);
    }

    .text-align-right {
        text-align: right;
    }

    .float-box .float-box-title h2 {
        padding-top: 19px;
        font-size: 16px;
        padding-right: 16px;
        padding-left: 22px;
        width: 100%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .pull-left {
        float: left;
    }

    .el-drawer__header {
        background-color: #e9e9e9;
        padding: 15px !important;
        margin-bottom: 0px;
    }

    .float-box-title {
        width: 100%;
        background-color: #ecf0f1;
    }

    .float-box .float-box-collapse-icon {
        position: absolute;
        right: 15px;
        top: 17px;
        z-index: 10001;
        font-size: 16px;
    }

    .action-icon {
        cursor: pointer;
        color: #777;
    }

    .botao-consultar-imagens {
        color: var(--white);
        background-color: var(--primary);
        border-color: var(--primary);
        display: inline-block;
        font-weight: 400;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        user-select: none;
        border: 1px solid transparent;
        padding: 0;
        font-size: 1rem;
        line-height: 1.5;
        border-radius: 0.25rem;
        transition: background-color 0.15s ease-in-out 0s,
            border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s,
            -webkit-box-shadow 0.15s ease-in-out 0s;
        width: 100% !important;
        height: 40px !important;
        line-height: 27px !important;
    }

    .botao-cancela-consultar-imagens {
        color: var(--white);
        background-color: #BE2727;
        border-color: #BE2727;
        margin-left: 0px;
        display: inline-block;
        font-weight: 400;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        user-select: none;
        border: 1px solid transparent;
        padding: 0;
        font-size: 1rem;
        line-height: 1.5;
        border-radius: 0.25rem;
        transition: background-color 0.15s ease-in-out 0s,
            border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s,
            -webkit-box-shadow 0.15s ease-in-out 0s;
        width: 100% !important;
        height: 40px !important;
        line-height: 27px !important;
    }

    img {
        width: 50px;
        height: 50px;
        padding: 8px;
        border-radius: 15px
    }
}
</style>
